import { useCallback } from 'react';
import { toast } from 'react-toastify';

const useToast = () => {
  const baseOptions = {
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

  const showSuccess = useCallback((message) => {
    toast.success(message, baseOptions);
  }, []);

  const showError = useCallback((message) => {
    toast.error(message, {
      ...baseOptions,
      autoClose: 5000,
    });
  }, []);

  const showWarning = useCallback((message) => {
    toast.warning(message, {
      ...baseOptions,
      autoClose: 4000,
    });
  }, []);

  const showInfo = useCallback((message) => {
    toast.info(message, baseOptions);
  }, []);

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};

export default useToast;
